import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import '../AdminEditUser/AdminEditUser.css';

const API_URL = process.env.REACT_APP_API_URL  ;

const CreateUser = () => {
  const navigate = useNavigate();
  const [ form, setForm] = useState({   name: '', lastname: '', email: '', country: '', city: '', phone: '', subscriptionLevel: '', password: '', 
    courses: [{
      courseSlug: "",
      level: "",
      status: "active",
    }],
    })

  const handleChange = (e) => {
    setForm ({ ...form, [e.target.name]: e.target.value});
  }

  const handleCourseChange = (index, e) => {
    const {name, value} = e.target;
    const updatedCourses = [ ...form.courses];
    updatedCourses[index] = {
      ...updatedCourses[index],
      [name]: value,
    };
    setForm((prev) => ({
      ...prev, 
      courses: updatedCourses,
    }));
  };

  const addCourse = () => {
    setForm((prev) => ({
      ...prev,
      courses: [
        ...prev.courses,
        {
          courseSlug: "",
          level: "",
          status: "active",
        },
      ],
    }));
  };

  const removeCourse = (index) => {
    const updatedCourses = form.courses.filter((_, i) => i !== index);
    setForm ((prev) => ({
      ...prev,
      courses: updatedCourses.length
        ? updatedCourses
        : [{courseSlug: "", level: "", status: "active"}],
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch(`${API_URL}/users`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(form)
    })
    .then(res => res.json())
    .then(data => {
      alert("User created, enjoy Admin!");
      navigate('/admin');
    });
  }

  return(
    <div className="edit-userform" >
      <h2 style={{fontFamily: "regular-futura", fontWeight: "400"}}>Create New User</h2>
      <form className="editUserForm" onSubmit={handleSubmit}>
          <div><p>Name</p>
            <input name="name" value={form.name} onChange={handleChange} placeholder="First Name"/>
          </div>
          <div><p>Last Name</p>
            <input name="lastname" value={form.lastname} onChange={handleChange} placeholder="Last Name"/>
          </div>
          <div><p>E-mail</p>
            <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="E-mail"/>
          </div>
          <div><p>Country</p>
            <input name="country" value={form.country} onChange={handleChange} placeholder="Country" />
          </div>
          <div><p>City</p>
            <input name="city" value={form.city} onChange={handleChange} placeholder="City" />
          </div>
          <div><p>Phone</p>
            <input name="phone" value={form.phone} onChange={handleChange} placeholder="Phone" />
          </div>
          <div><p>Subscription Level</p>
            <input name="subscriptionLevel" value={form.subscriptionLevel} onChange={handleChange} placeholder="Subscription Level" />
          </div>
          <div><p>Password</p>
            <input name="password" value={form.password} onChange={handleChange} placeholder="Change Password of the User**" />
          </div>
          <section className="selectOptions"><p>Courses</p>
            {form.courses.map((course, index) => (
              <div key={index} style={{ marginBottom: "15px"}}>
                <select name="courseSlug" value={course.courseSlug} onChange={(e) => handleCourseChange(index, e)}>
                  <option value="">Select Course</option>
                  <option value="fundamentals">Trading Fundamentals</option>
                  <option value="html">Html - Max: 200</option>
                  <option value="advanced-trading">Course3</option>
                </select>
                {/* <input name="level" type="number" value={course.level} onChange={(e) => handleCourseChange(index, e)} placeholder="Course Level" />  */}
                <select name="level" value={course.level} onChange={(e) => handleCourseChange(index, e)}>
                  <option value="">Select Level</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="300">300</option>
                  <option value="400">400</option>
                  <option value="500">500</option>
                  <option value="600">600</option>
                  <option value="700">700</option>
                  <option value="800">800</option>
                  <option value="900">900</option>
                  <option value="1000">1000</option>
                  <option value="1100">1100</option> 
                </select>
                <select name="status" value={course.status} onChange={(e) => handleCourseChange(index, e)} style={{height: "42px", borderRadius: "10px"}}>
                  <option value="active">Active</option>
                  <option value="expired">Expired</option>
                  <option value="trial">AcademyBrand</option>
                </select>
                <button type="button" onClick={() => removeCourse(index)}>Remove Course</button>
              </div>
            ))}
            <button type="button" onClick={addCourse} className="addCourseButton">Add Course</button>
          </section>

          <div style={{alignItems:"right !important"}} className="createButton" >
            <button type="submit" >Create User</button> 
          </div>
      </form>
    </div>
  )
}

export default CreateUser;